var _ = require('underscore');
var Backbone = require('backbone');
var Behaviors = require('Behaviors');
var Marionette = require('marionette');
var Dropdown = require('Dropdown');
var Entities = require('Entities');
var Router = require('Router');
var Validation = require('validation');
var Labels = EY.Consultation.Labels;
var Lookups = EY.Consultation.Lookups;
var Resources = EY.Consultation.Resources;
var User = EY.Consultation.CurrentUser;

var Layout = Marionette.View.extend({
    behaviors: [{ behaviorClass: Behaviors.Tooltip }],
    className: 'record-create',
    regions: {
        buttons: '#buttons',
        countries: '#country',
        offices: '#office',
        questionnaires: '#questionnaire',
        regions: '#region',
        subcountries: '#subcountry'
    },
    template: '#recordCreateLayout',
    ui: {
        region: '#regionContainer',
        subcountry: '#subcountryContainer',
        office: '#officeContainer'
    },
    initialize: function () {
        Validation.bind(this, {
            attributes: ['regionId', 'countryId', 'officeId', 'subcountryId', 'recordTypeId']
        });
    }
});

var ButtonsView = Marionette.View.extend({
    events: {
        'click @ui.save': 'save',
        'click @ui.cancel': 'close'
    },
    template: '#recordCreateAction',
    ui: {
        save: '#save',
        cancel: '#cancel'
    },
    close: function () {
        Router.navigate('#', { trigger: true });
    },
    save: function () {

        if (this.model.get("recordTypeId") === 'RecordType_NPO' && this.model.isValid()) {
            window.location = EY.Consultation.NpoWeb +"#RecordCreate";
        }else if (this.model.isValid()) {
            require('Record').start({ record: this.model });
            require('Redbox').configure({ reset: true });
        }
    }
});

var config = function (questionnaire) {
    return _.chain(questionnaire.get('answers')).filter(function (answer) {
        return answer.questionTypeId !== Lookups.QuestionType.Divider;
    }).reduce(function (answers, answer) {
        var value = answer;

        if (answer.questionTypeId === Lookups.QuestionType.Boolean || answer.questionTypeId === Lookups.QuestionType.Number) {
            value = answer.answer;
        }
        answers[answer.id] = value;
        return answers;
    }, {}).value();
}; // Transpose the array of questionnaire answers to an object with question-resourcekeys as property-names and individual answers as the property-values.

var validation = function () {
    return {
        countryId: function () { return !/Country/.test(this.get('geographyTypePath')) ? Labels.ErrorMsg.replace('{0}', Labels.Country) : ''; },
        officeId: function () { return this.get('configuration').DisplayOffice && !/Office/.test(this.get('geographyTypePath')) ? Labels.ErrorMsg.replace('{0}', Labels.Office) : ''; },
        regionId: function () { return !this.get('geographyTypePath') ? Labels.ErrorMsg.replace('{0}', Labels.Region) : ''; },
        subcountryId: function () { return this.get('configuration').DisplaySubCountry && !/SubCountry/.test(this.get('geographyTypePath')) ? Labels.ErrorMsg.replace('{0}', Labels.Region) : ''; }
    };
};

module.exports.start = function () {
    var consultation = require('Consultation');
    var questionnaires = new Entities.Questionnaires();
    var location = _.findWhere(Resources.CountriesFiltered, { text: User.location.country });
    var areaId = location ? '/' + _.first(location.id.slice(1, -1).split('/')) + '/' : '';
    var upn = new RegExp(User.upn);

    if (upn.test(Lookups.Configuration.PrivilegedUsers)) { //open the geography for specified users
        location = '';
        areaId = '';
    }
    var countries = new Entities.Geographies(_.filter(Resources.CountriesFiltered, function (country) { return country.id.indexOf(areaId) === 0; }));
    var subcountries = new Entities.Geographies(_.filter(Resources.SubCountriesFiltered, function (subcountry) { return subcountry.id.indexOf(areaId) === 0; }));
    var offices = new Entities.Geographies();
    var regions = new Entities.Geographies(_.filter(Resources.RegionsFiltered, function (region) { return region.id.indexOf(areaId) === 0; }));

    var record = new Entities.Record({
        assignedTo: User.upn,
        assignedToGivenName: User.givenName,
        createdBy: User.upn,
        creatorGivenName: User.givenName,
        creatorGPN: User.gpn
    });
    var layout = new Layout({
        model: record
    });

    record.validation = _.extend(record.validation || {}, validation());
    consultation.show({ view: layout });
    Dropdown.show({
        autoselect: true,
        collection: regions,
        childCollection: countries,
        region: layout.getRegion('regions'),
        onSelectionChanged: function (region) {
            if (region.id) {
                record.set({
                    geographyId: region.id,
                    geographyTypePath: region.get('typePath'),
                    regionId: region.id
                });
            }
        }
    });
    Dropdown.show({
        autoselect: true,
        collection: countries,
        parentCollection: regions,
        selection: location ? location.id : null,
        region: layout.getRegion('countries'),
        onSelectionChanged: function (country) {
            if (country.id) {
                questionnaires.fetch({ filter: { geographyId: country.id }, select: { answers: 1, fields: 1, approvers: 1, recordTypeId: 1 }, sort: { _id: 1 } })
                    .done(function () {
                        var questionnaire = questionnaires.first();
                        var configuration = config(questionnaire);

                        configuration.groups = questionnaire.get('approvers');
                        layout.ui.office.toggleClass('hidden', !configuration.DisplayOffice);
                        layout.ui.region.toggleClass('hidden', configuration.DisplaySubCountry);
                        layout.ui.subcountry.toggleClass('hidden', !configuration.DisplaySubCountry);
                        record.set({
                            configuration: configuration,
                            countryId: country.id,
                            fields: questionnaire.get('fields'),
                            geographyId: country.id,
                            geographyTypePath: country.get('typePath'),
                            link: Backbone.history.location.origin + '/#Record',
                            recordTypeId: ''
                        });
                        offices.reset(_.filter(Resources.OfficesFiltered, function (office) { return office.id.indexOf(country.id) === 0; }));
                    });
            }
        }
    });
    Dropdown.show({
        collection: subcountries,
        parentCollection: countries,
        region: layout.getRegion('subcountries'),
        onSelectionChanged: function (subcountry) {
            if (subcountry.id) {
                record.set({
                    geographyId: subcountry.id,
                    geographyTypePath: subcountry.get('typePath'),
                    subcountryId: subcountry.id
                });
            }
        }
    });
    Dropdown.show({
        collection: offices,
        parentCollection: countries,
        region: layout.getRegion('offices'),
        onSelectionChanged: function (office) {
            if (office.id) {
                record.set({
                    geographyId: office.id,
                    geographyTypePath: office.get('typePath'),
                    officeId: office.id
                });
            }
        }
    });
    Dropdown.show({
        collection: questionnaires,
        region: layout.getRegion('questionnaires'),
        resourceKeyAttribute: 'recordTypeId',
        onSelectionChanged: function (questionnaire) {
            if (questionnaire.id) {
                var configuration = config(questionnaire);

                configuration.groups = questionnaire.get('approvers');
                layout.ui.office.toggleClass('hidden', !configuration.DisplayOffice);
                layout.ui.region.toggleClass('hidden', configuration.DisplaySubCountry);
                layout.ui.subcountry.toggleClass('hidden', !configuration.DisplaySubCountry);
                record.set({
                    configuration: configuration,
                    fields: questionnaire.get('fields'),
                    questionnaireId: questionnaire.id,
                    recordTypeId: questionnaire.get('recordTypeId')
                });
            }
        }
    });
    layout.getRegion('buttons').show(new ButtonsView({
        model: record
    }));
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordCreate.js